<template>
  <b-modal id="partial-repay-modal" ref="modal" name="disburse" centered hide-footer hide-header>
    <center><h3><strong>{{ $t('TRANSACTION_INFO') }}</strong></h3></center>
    <center class="input-wrapper">
      <date-input
        :label="$t('TRANSACTION_DATE')"
        v-model="registeredOn"
        borderbottom
        required
        :validate="validateTransactionDate"
        ref="dateInputRef"
      />

      <text-input
        :label="$t('AMOUNT')"
        v-model="amount"
        :hint="changeDigitToViText(amount)"
        borderbottom
        required
        :validate="validateAmount"
        ref="amountInputRef"
      />

      <div class="controls">
        <primary-button @click="close" blue :text="$t('BACK')" />
        <primary-button @click="save" :text="$t('WAIVE')" />
      </div>
    </center>
  </b-modal>
</template>

<script>
import moment from 'moment';
import { watch, ref, computed } from '@vue/composition-api';

import PrimaryButton from '@/components/PrimaryButton';

import { DATE_FORMAT, DISPLAY_DATE_FORMAT } from '@/consts';
import { changeDigitToViText } from '@/helpers';

import DateInput from '@/components/DateInput';
import TextInput from '@/components/TextInput';

export default {
  name: 'WaiveInterestDialog',
  components: {
    PrimaryButton,
    DateInput,
    TextInput
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    disbursedOn: {
      type: String,
      required: true
    },
    repaymentAmount: {
      type: Number,
      required: true
    }
  },
  setup(props, { emit }) {
    const registeredOn = ref(moment().format(DISPLAY_DATE_FORMAT));
    const amount = ref(0);
    const modal = ref(null);

    const dateInputRef = ref(null);
    const amountInputRef = ref(null);

    const close = () => {
      emit('input', false);
    };

    const save = async () => {
      const inputs = [
        dateInputRef.value,
        amountInputRef.value
      ];

      let valid = true;

      inputs.forEach((input) => {
        const v = input.validateInput();
        valid = valid && v;
      });

      if (!valid) return;

      emit('waive', {
        registeredOn: moment(registeredOn.value, DISPLAY_DATE_FORMAT).format(DATE_FORMAT),
        amount: Math.round(Math.round(parseFloat(amount.value) * 1000) * 1000)
      });
    };

    const validateTransactionDate = (val) => {
      const date = moment(val, DISPLAY_DATE_FORMAT, true).startOf('day');

      if (date.isValid()) {
        const disbursementDate = moment(props.disbursedOn, DATE_FORMAT).startOf('day');
        const today = moment().startOf('day');

        if (
          (disbursementDate > date)
          || (today < date)
        ) {
          return 'INVALID_TRANSACTION_DATE';
        }

        return '';
      }

      return 'INVALID_DATE_FORMAT';
    };

    const validateAmount = (val) => {
      const amount_ = Math.round(Math.round(parseFloat(val) * 1000) * 1000);
      if (amount_ > props.repaymentAmount) {
        return 'INVALID_WAIVE_AMOUNT';
      }

      return '';
    };

    const popup = computed(() => props.value);
    watch(popup, (value) => {
      if (value) {
        modal.value.show();
      } else {
        modal.value.hide();
      }
    });

    return {
      modal,
      close,
      save,
      registeredOn,
      amount,
      dateInputRef,
      amountInputRef,
      validateTransactionDate,
      changeDigitToViText,
      validateAmount
    };
  },
};
</script>

<style lang="scss">
@import "~@/assets/scss/colors";

#partial-repay-modal {
  .modal-body {
    padding: 30px 15px;
  }

  h3 {
    margin-bottom: 20px;
  }

  .input-wrapper {
    > .input {
      width: 300px;
      text-align: left;
      margin-bottom: 20px;
    }
  }

  .controls {
    margin-top: 20px;

    .primary-button {
      margin-left: 15px;
      border-radius: 4px;
    }
  }
}
</style>
